import MainScene from './mainscene';

export default function( space, c )
{
    const container = c.slotScene.view;

    let mainScene = new MainScene();
    container.addChild( mainScene );
}




// WEBPACK FOOTER //
// ./src/reactive.es6